import type { IconDefinition } from '../index.tsx';

export const iconRotateLeft: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconRotateLeft',
  icon: [
    16,
    16,
    [],
    '',
    'M16 7.99896C16 12.2748 12.5172 15.7231 8.27586 15.7231C6.58621 15.7231 4.96552 15.2059 3.62069 14.2059C3.13793 13.8265 3.03448 13.1369 3.41379 12.6541C3.7931 12.1714 4.48276 12.0679 4.96552 12.4128C5.93103 13.1369 7.06897 13.5162 8.27586 13.5162C11.3103 13.5162 13.7931 11.0679 13.7931 7.99896C13.7931 4.96448 11.3103 2.5162 8.27586 2.5162C6.96552 2.5162 5.75862 2.96448 4.75862 3.75758L6.34483 5.3093C6.93103 5.89551 6.48276 6.92999 5.65517 6.92999H0.655172C0.275862 6.92999 0 6.61965 0 6.24034V1.24034C0 0.378269 1 -0.0355241 1.58621 0.550683L3.2069 2.20586C4.58621 0.998959 6.37931 0.309303 8.27586 0.309303C12.5172 0.309303 16 3.75758 16 7.99896Z',
  ],
};
